import { hotTags } from '@/mocks/home';

export default function TagCloud() {
  return (
    <section id="tags" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-14">
        <div className="mb-5 flex items-center gap-2">
          <i className="ri-price-tag-3-line text-lg text-primary-600"></i>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">吃瓜热词</h2>
          <span className="text-xs text-foreground-500">点一个顺藤摸瓜</span>
        </div>
        <div className="flex flex-wrap gap-2.5">
          {hotTags.map((tag, index) => (
            <a
              key={tag}
              href="#feed"
              className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-sm transition-colors ${
                index % 3 === 0
                  ? 'border-primary-200 bg-primary-100 text-primary-800 hover:bg-primary-200'
                  : index % 3 === 1
                    ? 'border-accent-200 bg-accent-100 text-accent-900 hover:bg-accent-200'
                    : 'border-background-300 bg-background-50 text-foreground-700 hover:bg-background-200'
              }`}
            >
              # {tag}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}